// stage
import index from '@/views/index/router/index';
// finance
import finance from '@/views/finance/router/index';
// credit
import credit from '@/views/credit/router/index';
// service
import service from '@/views/service/router/index';
// stage
import stage from '@/views/stage/router/index';
// customer
import customer from '@/views/customer/router/index';
// room
import room from '@/views/room/router/index';
// achivement
import achivement from '@/views/achivement/router/index';
// analyse
import analyse from '@/views/analyse/router/index';
// package
import packages from '@/views/package/router/index';
// booking
import booking from '@/views/booking/router/index';
// 5.10销售分析
import sale from '@/views/sale/router/index';

export default [
  ...index, ...finance, ...credit, ...service, ...stage, ...packages, ...customer, ...room, ...achivement, ...analyse, ...booking, ...sale
];
